import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [modalOpen, setModalOpen] = useState<'terms' | 'privacy' | null>(null);
  const closeModal = () => setModalOpen(null);
  return <>
      <footer className="bg-wine-dark text-cream/60 py-12 px-6" data-id="element-203">
        <div className="container mx-auto max-w-5xl text-center" data-id="element-204">
          <h3 className="font-serif text-2xl text-cream mb-6" data-id="element-205">
            7 Noches Para Volver a Tocarnos
          </h3>
          <p className="max-w-md mx-auto mb-8 text-sm leading-relaxed" data-id="element-206">
            Una guía diseñada para recuperar la intimidad sin presión,
            respetando los tiempos y emociones de ambos.
          </p>

          <div className="flex justify-center gap-8 text-sm mb-8" data-id="element-207">
            <button onClick={() => setModalOpen('terms')} className="hover:text-amber transition-colors underline underline-offset-4 decoration-transparent hover:decoration-amber" data-id="element-208">
              Términos y Condiciones
            </button>
            <button onClick={() => setModalOpen('privacy')} className="hover:text-amber transition-colors underline underline-offset-4 decoration-transparent hover:decoration-amber" data-id="element-209">
              Política de Privacidad
            </button>
          </div>

          <p className="text-xs opacity-40" data-id="element-210">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-211">
        {modalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-212">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-213" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto z-10" data-id="element-214">
              <button onClick={closeModal} className="absolute top-4 right-4 p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors text-charcoal" data-id="element-215">
                <X className="w-5 h-5" data-id="element-216" />
              </button>

              <div className="p-8 md:p-10" data-id="element-217">
                {modalOpen === 'terms' ? <TermsContent data-id="element-218" /> : <PrivacyContent data-id="element-219" />}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}
function TermsContent() {
  return <div className="prose prose-wine max-w-none" data-id="element-220">
      <h2 className="font-serif text-3xl font-bold text-wine-dark mb-6" data-id="element-221">
        Términos y Condiciones
      </h2>

      <h3 data-id="element-222">1. Uso del Producto</h3>
      <p data-id="element-223">
        Al comprar "7 Noches Para Volver a Tocarnos", adquieres una licencia
        personal e intransferible para uso privado. Queda prohibida su
        distribución, venta o reproducción total o parcial sin autorización
        expresa.
      </p>

      <h3 data-id="element-224">2. Propiedad Intelectual</h3>
      <p data-id="element-225">
        Todo el contenido, textos, imágenes y diseño de la guía están protegidos
        por derechos de autor. La compra no transfiere la propiedad intelectual,
        solo el derecho de uso personal.
      </p>

      <h3 data-id="element-226">3. Política de Reembolso</h3>
      <p data-id="element-227">
        Al tratarse de un producto digital de descarga inmediata, todas las
        ventas son finales. No ofrecemos reembolsos una vez que el producto ha
        sido enviado o descargado, salvo que exista un defecto técnico
        comprobable que impida su acceso.
      </p>

      <h3 data-id="element-228">4. Limitación de Responsabilidad</h3>
      <p data-id="element-229">
        Esta guía es un recurso educativo y de entretenimiento. No sustituye la
        terapia profesional ni el consejo médico. Los resultados pueden variar
        según cada pareja y su aplicación de las sugerencias.
      </p>

      <h3 data-id="element-230">5. Modificaciones</h3>
      <p data-id="element-231">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las actualizaciones entrarán en vigor inmediatamente después de
        su publicación en este sitio.
      </p>
    </div>;
}
function PrivacyContent() {
  return <div className="prose prose-wine max-w-none" data-id="element-232">
      <h2 className="font-serif text-3xl font-bold text-wine-dark mb-6" data-id="element-233">
        Política de Privacidad
      </h2>

      <h3 data-id="element-234">1. Datos que Recopilamos</h3>
      <p data-id="element-235">
        Solo recopilamos la información necesaria para procesar tu compra y
        entregar el producto: nombre, correo electrónico y datos de pago
        (procesados de forma segura por nuestros proveedores de pago).
      </p>

      <h3 data-id="element-236">2. Uso de la Información</h3>
      <p data-id="element-237">
        Utilizamos tus datos exclusivamente para:
        <ul data-id="element-238">
          <li data-id="element-239">Entregar el producto digital a tu correo.</li>
          <li data-id="element-240">Brindar soporte técnico si lo necesitas.</li>
          <li data-id="element-241">
            Enviarte actualizaciones relevantes sobre el producto (puedes darte
            de baja en cualquier momento).
          </li>
        </ul>
      </p>

      <h3 data-id="element-242">3. Protección de Datos</h3>
      <p data-id="element-243">
        Tus datos están protegidos con estándares de seguridad de la industria.
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros con fines comerciales.
      </p>

      <h3 data-id="element-244">4. Cookies</h3>
      <p data-id="element-245">
        Utilizamos cookies esenciales para el funcionamiento del carrito de
        compra y análisis anónimo de tráfico para mejorar la experiencia del
        sitio.
      </p>

      <h3 data-id="element-246">5. Contacto</h3>
      <p data-id="element-247">
        Si tienes dudas sobre cómo manejamos tus datos, puedes contactarnos
        respondiendo al correo de confirmación de tu compra.
      </p>
    </div>;
}